export default __webpack_public_path__ + "static/media/Brow_7_C1.3788690d.svg";